import { createFileRoute, Outlet, useParams } from '@tanstack/react-router'
import { LimitationCard } from '@/entities/limitation'
import { useTask } from '@/shared/api/menu-restriction'

export const Route = createFileRoute(
  '/_auth/applications/limitations/limitation/$limitationId/common'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { limitationId } = useParams({
    from: '/_auth/applications/limitations/limitation/$limitationId/common',
  })

  const { task, isLoading } = useTask({ id: limitationId })

  return (
    <>
      <LimitationCard task={task} isLoading={isLoading} />
      <Outlet />
    </>
  )
}
